<template>
  
    <div class="warp">
      <!-- 面包屑 -->
      <!-- <breadcrumb :back="false" :crubList="[{name:'首页推荐管理管理'},{name:'活动推荐列表'}]" :title="'活动推荐列表'"/> -->
      <div ref="condition">
      <el-button 
        class="addbtns"
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="addbtn"
        v-if="authorities.indexOf('sys:permission:background:hotAct:add')!=-1"
      >添加活动</el-button>
      </div>
      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        fit
        :height="bHeight"
        :header-cell-style="headerStyle"
        v-loading="loading"
                element-loading-text="请求中......"
      >
        <el-table-column
          prop="sort"
          show-overflow-tooltip
          
          label="序号"
          width="80px"
        >
        </el-table-column>
        <el-table-column
          prop="type"
          show-overflow-tooltip
          
          label="活动类型"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          show-overflow-tooltip
          
          label="活动名称"
        >
        </el-table-column>
        <el-table-column
          prop="referee"
          show-overflow-tooltip
          
          label="推荐人"
        >
        </el-table-column>
        <el-table-column
          prop="refereeTime"
          show-overflow-tooltip
          
          label="推荐时间"
        >
        </el-table-column>
        <el-table-column
          v-if="authorities.indexOf('sys:permission:background:hotAct:edit')!=-1 || (authorities.indexOf('permission:background:hotAct:del')!=-1)"
          label="操作"
          
          width="200px"
        >
          <template slot-scope="scope">
            <el-button
              size="small" type="primary" class="super" plain 
              @click="editoer(scope.row)"
              v-if="authorities.indexOf('sys:permission:background:hotAct:edit')!=-1"
            >编辑
            </el-button>
            <el-button
              size="small" type="danger" class="super" plain 
              @click="deleteDell(scope.row.id)"
              v-if="authorities.indexOf('sys:permission:background:hotAct:del')!=-1"
            >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加热点 -->
      <el-dialog
        title="添加产品"
        :visible.sync="dialogAdd"
        :before-close="cancel"
        :close-on-click-modal='false'
        width="400"
      >
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item
            label="活动名称"
            prop="sourceId"
            class="formitem"
            v-if="!edit"
          >
            <el-select
              v-model="ruleForm.sourceId"
              placeholder="请选择活动名称"
              filterable
              clearable
            >
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item,index) in newsDataSelect"
                :key="index"
                @click.native="chooseItem(item)"
              ></el-option>
            </el-select>
          </el-form-item>
          <div
            v-else
            class="nametitle"
          >
            <div>产品名称</div> {{ruleForm.name}}
          </div>
          <el-form-item label="活动类型">
            <el-input
              disabled
              v-model="ruleForm.type"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="序号"
            prop="sort"
          >
            <el-input v-model="ruleForm.sort"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetForm('ruleForm')">取消</el-button>
            <el-button
              type="primary"
              @click="submitForm('ruleForm')"
            >确认</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
</template>

<script>
// import breadcrumb from '../../components/breadcrumb';
export default {
    components: {
        // breadcrumb,
    },
    data() {
        return {
            loading:false,
            bHeight: void 0,
            authorities: JSON.parse(window.localStorage.getItem('authorities')),
            sendInfo: {
                currentPage: 1, //页码
                pageSize: 10, //条数
            }, //检索提交数据
            tableData: [], //表格数据
            totalPage: null, //总页码
            dialogAdd: false,
            classifyList: [], //分类
            ruleForm: {
                sort: null,
                sourceId:null,
                type:null,
            },
            newsDataSelect:[],
            edit: false, //是否编辑
            rules: {
                 sort: [
                    { required: true, message: '请输入序号', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (this.$reg.numPint.test(value) == false) {
                                callback(new Error('请输入正整数'))
                            } else {
                                return callback()
                            }
                        },
                        trigger: 'blur',
                    },
                ],
                sourceId:{ required: true, message: '请选择产品名称', trigger: 'change' }
            
            }
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    methods: {
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.multipleTable && this.$refs.multipleTable.doLayout) {
                this.$refs.multipleTable.doLayout()
              }
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
      // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
      chooseItem(data){
        this.ruleForm = Object.assign(this.ruleForm,data)
      },
        // 添加按钮
        addbtn() {
            // this.edit = false
            // this.getSelect()
            this.$router.push({path:`/HomePageMgt/ActivityList/add`,query:{index:'/HomePageMgt/ActivityList'}})
        },
        submitForm(formName) {
            const that = this
            that.$refs[formName].validate((valid) => {
                if (valid) {
                    if (!that.edit) {
                        that.$axioscBody.post('/backstage/act/add', that.ruleForm).then(async (r) => {
                            if (r.code == 200) {
                                that.$message({
                                    type: 'success',
                                    message: r.msg
                                });
                                await that.getData();
                                that.resetForm(formName)
                            } else {
                                that.$alert(r.msg)
                            }
                        })
                    } else {
                        that.$axioscBody.put('/backstage/act/edit', that.ruleForm).then(async (r) => {
                            if (r.code == 200) {
                                that.$message({
                                    type: 'success',
                                    message: r.msg
                                });
                                await that.getData()
                                that.resetForm(formName)
                            } else {
                                that.$alert(r.msg)
                            }
                        })
                    }

                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.ruleForm={
                sort: null,
                sourceId:null,
                type:null,
            }
            this.dialogAdd = false
            this.$refs[formName].resetFields();
        },
        deleteDell(id) {
            this.$confirm('确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const {code,msg} = await this.$axiosc.delete('/backstage/act/del', { params: { id: id } })
                if (code == 200) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        await this.getData()
                    }else {
                        this.$alert(msg)
                    }
            }).catch(() => {});
        },
        // 编辑回显
        editoer(row) {
          //   this.ruleForm = row
          // this.edit = true;
          // this.dialogAdd = true
          this.$router.push({path:`/HomePageMgt/ActivityList/edit/${row.id}`,query:{index:'/HomePageMgt/ActivityList'},params:{id:row.id}})
        },
        //切换每页显示条数
        handleSizeChange(val) {
            this.sendInfo.pageSize = val;
            this.getData();
        },
        //切换页码
        handleCurrentChange(val) {
            this.sendInfo.currentPage = val;
            this.getData();
        },
        //取消按钮
        cancel: function(type) {
            this.dialogAdd = false;
        },
        async getSelect() {
            const {data,msg,code} = await this.$axiosc.get('backstage/act/select', {})
            if (code == 200) {
                    this.newsDataSelect = data || [];
                } else {
                    this.$alert(msg)
                }
            this.dialogAdd = true

        },
        //获取数据
        async getData() {
          try{
            this.loading = true
           const {code,data,msg} = await this.$axiosc.get('backstage/act/list', {})
            this.loading = false
            if (code == 200) {
                    this.tableData = data || [];
                    this.totalPage = data.totalElements || 0;
                } else {
                    this.$alert(msg)
                }
          }catch(e){
            this.loading = false
          }
        },
    },
    created(){
      this.getData();
    },
    mounted() {
      const that = this
        let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) + 20
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  20
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    }
}
</script>
<style scoped="scoped" lang="scss">
.forms {
    /deep/ .el-select {
        width: 300px;
    }
    .child {
        .remark {
            /deep/ .el-textarea__inner {
                min-height: 122px !important;
            }
        }
        .name {
            width: 123px;
        }
    }
}

.tabs {
    border: 0;
}

.addbtns {
    margin: 0px 0 10px;
}

/deep/ .el-dialog {
    width: 450px;
}
</style>
